import React from "react";

import classNames from "classnames";

import styles from "./ControlPanelActionRow.module.scss";

interface Props {
  leftComponent?: React.ReactNode;
  rightComponent?: React.ReactNode;
  className?: string;
  borderBottom?: boolean;
}

const ControlPanelActionRow: React.FC<Props> = ({
  leftComponent,
  rightComponent,
  className,
  borderBottom = true,
}) => {
  return (
    <div
      className={classNames(styles.controlPanelActionRow, {
        [className!]: className,
        [styles.borderBottom]: borderBottom,
        [styles.oneColumn]:
          leftComponent === undefined || rightComponent === undefined,
      })}
    >
      {leftComponent !== undefined ? leftComponent : null}
      {rightComponent !== undefined ? rightComponent : null}
    </div>
  );
};

export default ControlPanelActionRow;
